module.exports = __webpack_public_path__ + "d30f09f733da6ba49eb296f48f830281.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/VS2@2x.png
// module id = 813
// module chunks = 0